import * as React from "react";

const InformationIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="48" height="48" viewBox="0 0 640 640">
            {" "}
            <path d="M320 576c141.4 0 256-114.6 256-256S461.4 64 320 64 64 178.6 64 320s114.6 256 256 256zm-32-352c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm-8 64h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24h24v-64h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24z" />{" "}
        </svg>
    );
};
export default React.memo(InformationIcon);
